import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledContactInfoSummary = styled.div`
  .payment-info {
    text-transform: capitalize;
  }
  .accordion-container {
    border-top: ${toRem(1)} solid ${color.neutral40};
    .additional-info {
      word-wrap: break-word;
    }
  }
  [dir='rtl'] & {
    .ltr-number {
      text-align: end;
    }
  }
  .item-value {
    word-wrap: break-word;
    &:first-of-type {
      padding-top: ${toRem(8)};
    }
  }
`;
